module.exports = __webpack_public_path__ + "static/media/social-icon-x-green.71f96417.svg";